var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor appstore-update-review-status" },
    [
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("auto.appStoreUpdateReviewStatusReviewId"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "App Store Review ID",
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.reviewId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "reviewId", $$v)
              },
              expression: "clone.reviewId",
            },
          }),
          _vm._v(" "),
          _c("small", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "auto.appStoreUpdateReviewStatusDurumuGNcellenecekYorumunIdsi"
                )
              )
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("auto.appStoreUpdateReviewStatusDurum"))),
          ]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              model: {
                value: _vm.clone.status,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "status", $$v)
                },
                expression: "clone.status",
              },
            },
            [
              _c("a-select-option", { attrs: { value: "new" } }, [
                _vm._v(_vm._s(_vm.$t("auto.appStoreUpdateReviewStatusYeni"))),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "replied" } }, [
                _vm._v(
                  _vm._s(_vm.$t("auto.appStoreUpdateReviewStatusYanTland"))
                ),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "resolved" } }, [
                _vm._v(_vm._s(_vm.$t("auto.appStoreUpdateReviewStatusZLd"))),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("small", [
            _vm._v(
              _vm._s(_vm.$t("auto.appStoreUpdateReviewStatusYorumunYeniDurumu"))
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }